import { CurrentCardService } from '@addins/core/core';
import { Component, Input, OnInit, Type } from '@angular/core';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { AddinView } from '@techwan/ionic-core';
import { CardsProviderService } from '../../services/cards-provider/cards-provider.service';

@AddinView({
  name: 'FullView'
})
@Component({
  selector: 'app-full-view',
  templateUrl: './full-view.component.html',
  styleUrls: ['./full-view.component.scss']
})
export class FullViewComponent implements OnInit {
  @Input()
  callcard: CallCard = null;

  get customContent(): Type<any>[] {
    return this.cardsProvider.cards;
  }

  constructor(private currentCardService: CurrentCardService, private cardsProvider: CardsProviderService) {}

  ngOnInit() {
    if (!this.callcard) {
      this.callcard = this.currentCardService.current;
    }
  }
}
